const MAX_QUERY_LENGTH = 2000;

function hasSemanticComponent(query) {
    if (query.length > MAX_QUERY_LENGTH) return true;
    const stripped = query
        .replace(/-?\w+:("[^"]*"|\S+)/g, "")
        .replace(/\*/g, "")
        .replace(/\b(AND|OR|NOT)\b/gi, "")
        .trim();
    return stripped.length > 0;
}

module.exports = { hasSemanticComponent };
